import { dateValueGetter, getValueBgClass, headerInfoTooltipDef } from '../../lib/utils';
import formatDate from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import differenceInDays from 'date-fns/differenceInDays';
import { ColDef } from '@ag-grid-community/core';

export const Options = [
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'date',
    flex: 1,
    headerName: 'Date of Trade',
    initialSort: 'desc' as ColDef['initialSort'],
    ...headerInfoTooltipDef('Date Trade was Executed'),
    valueFormatter: ({ value }: any) => formatDate(parseISO(value), 'MM/dd/yy'),
    valueGetter: ({ data }: any) => dateValueGetter(data.date),
    width: 100,
  },
  {
    field: 'ticker',
    ...headerInfoTooltipDef('A Unique Series of Letters Assigned to a Security for Trading Purposes'),
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellStyle: { fontWeight: 'bold' },
    flex: 1,
    width: 90,
  },
  {
    field: 'put_call',
    headerName: 'Put/Call',
    ...headerInfoTooltipDef(
      'A Call Option Gives You The Right To Buy a Stock At A Certain Price, and a Put Give You The Option to Sell a Stock at a Certain Price',
    ),
    cellClass: 'ticker-cell',
    flex: 1,
    width: 50,
  },
  {
    field: 'strike_price',
    headerName: 'Strike Price',
    ...headerInfoTooltipDef('The Price at Which the Holder Can Buy/Sell the Underlying Equity when exercised.'),
    cellClass: ({ data }: any) => {
      let value = 0;
      if (data.sentiment === 'BULLISH') {
        value = 1;
      } else if (data.sentiment === 'BEARISH') {
        value = -1;
      }
      return getValueBgClass(value);
    },
    cellStyle: { textAlign: 'left' },
    flex: 1,
    valueFormatter: ({ value }: any) => {
      if (!value) return '-';
      return `$${Number(value).toFixed(2)}`;
    },
    width: 70,
  },
  {
    field: 'date_expiration',
    headerName: 'DTE',
    ...headerInfoTooltipDef('Number of Days Until Option Expires'),
    cellClass: 'ticker-cell',
    flex: 1,
    valueGetter: ({ data }: any) => {
      if (!data.date_expiration) return 0;
      return Number(differenceInDays(new Date(data.date_expiration), new Date()));
    },
    width: 40,
  },
  {
    field: 'sentiment',
    headerName: 'Sentiment',
    ...headerInfoTooltipDef('Sentiment'),
    cellClass: 'ticker-cell',
    flex: 1,
    width: 60,
  },
] as ColDef[];
